module.exports = __webpack_public_path__ + "img/BOX_characters.59464c83.png";